import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { I18n } from './i18n';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  template: `
    <div class="shell" [attr.dir]="i18n.dir()" [class.authenticated]="auth.isAuthenticated()">
      <aside class="sidebar" *ngIf="auth.isAuthenticated()">
        <h1>{{ i18n.t('app.title') }}</h1>
        <nav>
          <a routerLink="/responses" routerLinkActive="active">{{ i18n.t('nav.responses') }}</a>
          <a routerLink="/dashboard" routerLinkActive="active">{{ i18n.t('nav.dashboard') }}</a>
          <a routerLink="/systems" routerLinkActive="active">{{ i18n.t('nav.systems') }}</a>
          <a routerLink="/users" routerLinkActive="active">{{ i18n.t('nav.users') }}</a>
        </nav>
        <hr />
        <div class="row">
          <button class="ghost" (click)="setLocale('en')">EN</button>
          <button class="ghost" (click)="setLocale('ar')">عربي</button>
        </div>
        <button class="ghost" (click)="signOut()">{{ i18n.t('nav.signOut') }}</button>
      </aside>
      <main class="content">
        <router-outlet />
      </main>
    </div>
  `,
})
export class AppComponent {
  i18n = inject(I18n);
  auth = inject(AuthService);

  constructor() {
    document.documentElement.lang = this.i18n.locale();
    document.documentElement.dir = this.i18n.dir();
  }

  setLocale(l: 'en' | 'ar') { this.i18n.setLocale(l); }
  signOut() { this.auth.logout(); }
}
